import { FACILITY_ICONS } from '@/config/facilities.js';

export function useFacilities() {
  const getFacilityIcon = function (facility) {
    return FACILITY_ICONS[facility] || 'question';
  };

  return { getFacilityIcon };
}
